import React from "react";
import Button from "shared/components/button";
import { useRegDetail } from "shared/context/regDetail";
import DynamicFormRenderer from "shared/form/renderer";
import { useCopies } from "shared/hooks/useCopies";
import { CreateOrgAdminService } from "../../types";
import { useParticipantDetails } from "../../../../../context/participantDetails";
import { ApiRegistrationFormForRegResponse } from "../../../../../../../shared/types/ApiRegistrationFormForRegResponse";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function OrgAdminForm(props: { service: CreateOrgAdminService }) {
  const { currencyCode, id } = useRegDetail();
  const { participantDetails } = useParticipantDetails();
  const copies = useCopies();
  return (
    <React.Fragment>
      <DynamicFormRenderer
        key={props.service.orgAdminFormKey}
        enableReinitialize={true}
        formRef={props.service.formRef}
        schemaList={props.service.orgAdminForm?.profile || []}
        formSubmitHandler={props.service.submitHandler}
        parseValuesOnSubmitToApiReq={true}
        customData={{
          organizationId: props.service.organizationId,
          currencyCode,
          registrationId: id,
          registrationFormId: props.service.orgAdminForm?.id,
          registrationParticipantId: participantDetails?.registrationParticipantId,
          validateEmailDomain: props.service.isCreateMode
            ? (props.service.orgAdminForm as ApiRegistrationFormForRegResponse).validateEmailDomain
            : undefined,
          invalidEmailDomainErrorMessage: props.service.isCreateMode
            ? (props.service.orgAdminForm as ApiRegistrationFormForRegResponse).invalidEmailDomainErrorMessage
            : undefined
        }}
      />

      <ButtonGroup inlineFormButtons>
        <Button label={copies.get("save")} onClick={() => props.service.formRef?.current?.submitForm()} />
      </ButtonGroup>
    </React.Fragment>
  );
}
